(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kimaia-routine-email"] && !Shopify.designMode) return;
  try {
    (() => {
  const requests = new Map();
  const text = (value, limit = 2000) => String(value || '').trim().slice(0, limit);
  const safeUrl = (value, image = false) => {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
      const url = new URL(value, 'https://kimaia.nl');
      if (url.protocol !== 'https:') return '';
      if (url.username || url.password || url.port) return '';
      if (image ? url.hostname !== 'cdn.shopify.com' && url.hostname !== 'kimaia.nl' : !['kimaia.nl', 'www.kimaia.nl'].includes(url.hostname)) return '';
      return url.href;
    } catch (_) { return ''; }
  };
  const routineText = (value, limit = 2000) => typeof value === 'string' ? text(value, limit) : '';
  const normalizeRoutine = (items) => {
    if (items === undefined) return null;
    if (!Array.isArray(items) || items.length < 1 || items.length > 3) throw new Error('Invalid routine items');
    return items.map((item) => {
      if (!item || typeof item !== 'object' || Array.isArray(item)) throw new Error('Invalid routine item');
      const title = routineText(item.title, 250);
      const url = safeUrl(item.url);
      if (!title || !url) throw new Error('Invalid routine product');
      return {title, url, image: safeUrl(item.image, true), price: routineText(item.price, 80),
        reason: routineText(item.reason, 700), usage: routineText(item.usage, 500)};
    });
  };
  async function post(path, body) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(`https://a.klaviyo.com/client/${path}/?company_id=VrWrPN`, {
        method: 'POST',
        headers: {'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2026-07-15'},
        body: JSON.stringify(body),
        signal: controller.signal
      });
      if (!response.ok) throw new Error('Routine request was not accepted');
    } finally { clearTimeout(timer); }
  }
  window.requestRoutineEmail = async (payload) => {
    const email = text(payload.email, 254).toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) throw new Error('Invalid email');
    const routineItems = normalizeRoutine(payload.routineItems);
    const product = payload.primary || {};
    const alternative = payload.alternative || {};
    const properties = {
      quiz: 'KIMAIA Routine Finder', quiz_version: '2026-09', email_requested: true, heeft_email: 'ja',
      locale: String(payload.locale || '').startsWith('en') ? 'en' : 'nl',
      rec_titel: text(product.title, 250), rec_url: safeUrl(product.url), rec_beeld: safeUrl(product.image, true),
      rec_prijs: text(product.price, 80), rec_rol: '', rec_inclusief: '',
      samenvatting: text(payload.summary), motivatie: text(Array.isArray(payload.why) ? payload.why.join(' ') : payload.why),
      routine_stappen: text(payload.nextStep),
      alt_1_titel: text(alternative.title, 250), alt_1_url: safeUrl(alternative.url),
      alt_1_prijs: text(alternative.price, 80), alt_1_rol: text(payload.alternativeNote, 600),
      result_url: safeUrl(payload.resultsUrl)
    };
    if (routineItems) {
      properties.routine_items = routineItems;
      properties.routine_total = routineText(payload.routineTotal, 80);
      properties.routine_title = routineText(payload.routineTitle, 180);
    }
    const fingerprint = JSON.stringify([email, properties]);
    let request = requests.get(fingerprint);
    if (!request) {
      request = {id: crypto.randomUUID(), sent: false, newsletter: false};
      requests.set(fingerprint, request);
    }
    const attributes = {email};
    if (text(payload.firstName, 70)) attributes.first_name = text(payload.firstName, 70);
    const profile = {data: {type: 'profile', attributes}};
    if (!request.sent) {
      await post('events', {data: {type: 'event', attributes: {
        unique_id: request.id,
        properties,
        metric: {data: {type: 'metric', attributes: {name: 'Quiz Completed'}}},
        profile
      }}});
      request.sent = true;
    }
    let newsletterAccepted = false;
    if (payload.newsletterConsent === true) {
      if (!request.newsletter) {
        try {
          await post('subscriptions', {data: {type: 'subscription', attributes: {
            custom_source: 'KIMAIA Routine Finder — optional newsletter', profile
          }, relationships: {list: {data: {type: 'list', id: 'U9TApw'}}}}});
          request.newsletter = true;
        } catch (_) {}
      }
      newsletterAccepted = request.newsletter;
    }
    return {ok: true, newsletterAccepted};
  };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kimaia-routine-player"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kimaia-routine-player')) {
    customElements.define('kimaia-routine-player', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.poster = this.querySelector('.kimaia-routine-player__poster');
        this.frame = this.querySelector('.kimaia-routine-player__frame');
        this.message = this.querySelector('.kimaia-routine-player__status');
        this.buttonText = this.poster.querySelector('.kimaia-routine-player__button-text');
        this.watchText = this.buttonText.textContent;
        this.attempt = 0;
        this.sourceIndex = 0;
        this.poster.addEventListener('click', () => this.start(), { signal: this.controller.signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.suspend();
        }, { signal: this.controller.signal });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (!entries[0].isIntersecting) this.suspend();
          }, { threshold: 0 });
          this.observer.observe(this);
        }
      }

      disconnectedCallback() {
        this.release();
        if (this.poster) this.poster.hidden = false;
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
      }

      setMessage(text) {
        this.message.textContent = text;
        this.message.hidden = !text;
      }

      clearWatchdog() {
        window.clearTimeout(this.watchdog);
        this.watchdog = null;
      }

      armWatchdog(video, attempt) {
        if (this.watchdog) return;
        this.watchdog = window.setTimeout(() => {
          if (this.video === video && this.attempt === attempt) this.fail();
        }, 15000);
      }

      release() {
        this.attempt = (this.attempt || 0) + 1;
        this.clearWatchdog();
        this.starting = false;
        this.mediaController?.abort();
        const video = this.video;
        this.video = null;
        if (video) {
          video.pause();
          video.removeAttribute('src');
          video.load();
          video.remove();
        }
      }

      suspend() {
        if (this.starting) {
          this.release();
          this.poster.hidden = false;
        } else {
          this.video?.pause();
          this.clearWatchdog();
        }
        this.setMessage('');
      }

      fail(tryLighterSource = true) {
        const focusWasInVideo = document.activeElement === this.video;
        if (tryLighterSource && this.sources?.length) {
          this.sourceIndex = Math.min(this.sourceIndex + 1, this.sources.length - 1);
        }
        this.release();
        this.poster.hidden = false;
        this.buttonText.textContent = this.dataset.retry;
        this.setMessage(this.dataset.error);
        if (focusWasInVideo) this.poster.focus({ preventScroll: true });
      }

      selectSources(video) {
        const available = Array.from(video.querySelectorAll('source')).map(source => ({
          url: source.dataset.src,
          format: source.dataset.format,
          type: source.type,
          height: Number(source.dataset.height) || 0
        })).filter(source => source.url);
        video.querySelectorAll('source').forEach(source => source.remove());
        const mp4 = available.filter(source => source.format === 'mp4').sort((a, b) => a.height - b.height);
        const medium = mp4.filter(source => source.height <= 720).pop() || mp4[0];
        const small = mp4.filter(source => source.height <= 480).pop() || mp4[0];
        const hls = available.find(source => source.format === 'm3u8' && video.canPlayType(source.type));
        const connection = navigator.connection;
        const saveData = connection?.saveData || /^(slow-)?2g$/.test(connection?.effectiveType || '');
        const choices = saveData ? [small, medium, hls] : [hls, medium, small];
        return choices.filter((source, index) => source && choices.findIndex(other => other?.url === source.url) === index);
      }

      start() {
        if (this.starting) return;
        this.release();
        this.frame.appendChild(this.querySelector('template').content.cloneNode(true));
        const video = this.frame.querySelector('video');
        this.video = video;
        if (!video) {
          this.fail(false);
          return;
        }
        this.sources = this.selectSources(video);
        const source = this.sources[Math.min(this.sourceIndex, this.sources.length - 1)];
        if (!source) {
          this.fail(false);
          return;
        }
        this.mediaController = new AbortController();
        const options = { signal: this.mediaController.signal };
        const attempt = this.attempt;
        let lastTime = 0;
        const current = () => this.video === video && this.attempt === attempt;
        video.addEventListener('play', () => {
          if (!current()) return;
          document.querySelectorAll('video').forEach(other => {
            if (other !== video && !other.paused) other.pause();
          });
        }, options);
        video.addEventListener('playing', () => {
          if (!current()) return;
          this.starting = false;
          this.clearWatchdog();
          this.setMessage('');
        }, options);
        video.addEventListener('timeupdate', () => {
          if (!current() || video.currentTime <= lastTime) return;
          lastTime = video.currentTime;
          this.clearWatchdog();
          this.setMessage('');
        }, options);
        video.addEventListener('pause', () => {
          if (!current()) return;
          if (this.starting) {
            this.release();
            this.poster.hidden = false;
          }
          this.clearWatchdog();
          this.setMessage('');
        }, options);
        const waiting = () => {
          if (!current() || video.paused) return;
          this.setMessage(this.dataset.loading);
          this.armWatchdog(video, attempt);
        };
        video.addEventListener('waiting', waiting, options);
        video.addEventListener('stalled', waiting, options);
        video.addEventListener('ended', () => {
          if (!current()) return;
          this.starting = false;
          this.clearWatchdog();
          this.setMessage('');
        }, options);
        video.addEventListener('error', () => {
          if (current()) this.fail();
        }, options);
        this.starting = true;
        this.poster.hidden = true;
        this.buttonText.textContent = this.watchText;
        this.setMessage(this.dataset.loading);
        this.armWatchdog(video, attempt);
        video.preload = 'auto';
        video.src = source.url;
        video.load();
        video.focus({ preventScroll: true });
        try {
          const playback = video.play();
          if (playback?.catch) playback.catch(error => {
            if (current()) this.fail(error.name !== 'NotAllowedError' && error.name !== 'AbortError');
          });
        } catch (error) {
          if (current()) this.fail(error.name !== 'NotAllowedError' && error.name !== 'AbortError');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kimaia-routine-quiz"] && !Shopify.designMode) return;
  try {
    (function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.KimaiaRoutineEngine = api;
}(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  // Saved v2/v3 result links retain their original recommendation contract.
  var legacy = (function () {

  function option(value, labelKey, detailKey) { return { value: value, labelKey: labelKey, detailKey: detailKey || null }; }
  var STEP_DEFS = {
    goal: { titleKey:'step_goal_title', subtitleKey:'step_goal_subtitle', options:[option('skin','goal_skin','goal_skin_detail'),option('hair','goal_hair','goal_hair_detail'),option('joints','goal_joints','goal_joints_detail'),option('nutrition','goal_nutrition','goal_nutrition_detail'),option('discover','goal_discover','goal_discover_detail')] },
    hairFocus: { titleKey:'step_hair_title', subtitleKey:'step_hair_subtitle', options:[option('hair','hair_focus_hair'),option('nails','hair_focus_nails'),option('both','hair_focus_both')] },
    nutrition: { titleKey:'step_nutrition_title', subtitleKey:'step_nutrition_subtitle', options:[option('protein','nutrition_protein','nutrition_protein_detail'),option('omega','nutrition_omega','nutrition_omega_detail')] },
    discover: { titleKey:'step_discover_title', subtitleKey:'step_discover_subtitle', options:[option('care','discover_care'),option('collagen','discover_collagen'),option('protein','discover_protein'),option('omega','discover_omega')] },
    collagenRoutine: { titleKey:'step_collagen_routine_title', subtitleKey:'step_collagen_routine_subtitle', options:[option('start','routine_start'),option('replace','routine_replace'),option('covered','collagen_covered')] },
    world: { titleKey: 'step_world_title', subtitleKey: 'step_world_subtitle', options: [option('beauty','world_beauty','world_beauty_detail'),option('body','world_body','world_body_detail'),option('base','world_base','world_base_detail'),option('help','world_help','world_help_detail')] },
    help: { titleKey: 'step_help_title', subtitleKey: 'step_help_subtitle', options: [option('care','help_care'),option('collagen','help_collagen'),option('protein','help_protein'),option('omega','help_omega')] },
    beauty: { titleKey: 'step_beauty_title', subtitleKey: 'step_beauty_subtitle', options: [option('collagen','beauty_collagen'),option('lipcare','beauty_lipcare'),option('oil','beauty_oil'),option('tools','beauty_tools')] },
    collagen: { titleKey: 'step_collagen_title', subtitleKey: 'step_collagen_subtitle', options: [option('bovine','collagen_bovine'),option('marine','collagen_marine'),option('plant','collagen_plant'),option('either','preference_either')] },
    lipcare: { titleKey: 'step_lipcare_title', subtitleKey: 'step_lipcare_subtitle', options: [option('one','lipcare_one'),option('trio','lipcare_trio'),option('compare','lipcare_compare')] },
    oil: { titleKey: 'step_oil_title', subtitleKey: 'step_oil_subtitle', options: [option('face','oil_face'),option('body','oil_body'),option('compare','oil_compare')] },
    tools: { titleKey: 'step_tools_title', subtitleKey: 'step_tools_subtitle', options: [option('cupping','tools_cupping'),option('hotcold','tools_hotcold'),option('compare','tools_compare')] },
    protein: { titleKey: 'step_protein_title', subtitleKey: 'step_protein_subtitle', options: [option('plant','protein_plant'),option('whey','protein_whey'),option('either','preference_either')] },
    proteinRoutine: { titleKey: 'step_protein_routine_title', subtitleKey: 'step_protein_routine_subtitle', options: [option('start','routine_start'),option('replace','routine_replace'),option('covered','protein_covered')] },
    omegaRoutine: { titleKey: 'step_omega_routine_title', subtitleKey: 'step_omega_routine_subtitle', options: [option('start','omega_start'),option('replace','omega_replace'),option('covered','omega_covered')] },
    budget: { titleKey: 'step_budget_title', subtitleKey: 'step_budget_subtitle', options: [option('40','budget_40'),option('60','budget_60'),option('any','budget_any')] }
  };
  var productMeta = {
    valley: { handle:'kimaia-valley-glow-collagen', world:'beauty', roleKey:'role_valley', usageKey:'usage_collagen' },
    ocean: { handle:'kimaia-ocean-glow-collagen', world:'beauty', roleKey:'role_ocean', usageKey:'usage_collagen' },
    silk: { handle:'kimaia-silk-gloss', world:'beauty', roleKey:'role_silk', usageKey:'usage_silk' },
    trio: { handle:'kimaia-silk-gloss-trio', world:'beauty', roleKey:'role_trio', usageKey:'usage_silk' },
    face: { handle:'kimaia-glow-up-face-oil', world:'beauty', roleKey:'role_face', usageKey:'usage_face' },
    shimmer: { handle:'kimaia-golden-drip-shimmer-oil', world:'beauty', roleKey:'role_shimmer', usageKey:'usage_shimmer' },
    cupping: { handle:'kimaia-facial-cupping-set', world:'beauty', roleKey:'role_cupping', usageKey:'usage_tools' },
    hotcold: { handle:'kimaia-hot-cold-therapy-set', world:'beauty', roleKey:'role_hotcold', usageKey:'usage_tools' },
    vegan: { handle:'kimaia-vegan-vitality-protein', world:'body', roleKey:'role_vegan', usageKey:'usage_protein' },
    pure: { handle:'kimaia-pure-earth-protein', world:'body', roleKey:'role_pure', usageKey:'usage_protein' },
    omega: { handle:'kimaia-algae-omega', world:'base', roleKey:'role_omega', usageKey:'usage_omega' }
  };
  Object.keys(productMeta).forEach(function(key){ productMeta[key].descriptionKey = productMeta[key].roleKey; });
  function validAnswer(key, value) {
    return typeof value === 'string' && STEP_DEFS[key] && STEP_DEFS[key].options.some(function(o){return o.value === value;});
  }
  function cleanValues(input) {
    var out = {};
    Object.keys(STEP_DEFS).forEach(function(k){ if (input && validAnswer(k,input[k])) out[k]=input[k]; });
    return out;
  }
  function route(a) {
    if (a.goal) {
      if (a.goal==='skin') return {world:'beauty',topic:a.beauty,goal:'skin'};
      if (a.goal==='hair') return {world:'beauty',topic:'collagen',goal:'hair'};
      if (a.goal==='joints') return {world:'beauty',topic:'collagen',goal:'joints'};
      if (a.goal==='nutrition') return {world:a.nutrition==='protein'?'body':'base',topic:a.nutrition,goal:'nutrition'};
      if (a.goal==='discover') {
        if (a.discover==='care') return {world:'beauty',topic:a.beauty,goal:'discover'};
        if (a.discover==='collagen') return {world:'beauty',topic:'collagen',goal:'discover'};
        if (a.discover==='protein') return {world:'body',topic:'protein',goal:'discover'};
        if (a.discover==='omega') return {world:'base',topic:'omega',goal:'discover'};
      }
      return {world:null,topic:null,goal:a.goal};
    }
    if (a.world==='beauty') return {world:'beauty',topic:a.beauty};
    if (a.world==='body') return {world:'body',topic:'protein'};
    if (a.world==='base') return {world:'base',topic:'omega'};
    if (a.world==='help') {
      if (a.help==='care') return {world:'beauty',topic:a.beauty};
      if (a.help==='collagen') return {world:'beauty',topic:'collagen'};
      if (a.help==='protein') return {world:'body',topic:'protein'};
      if (a.help==='omega') return {world:'base',topic:'omega'};
    }
    return {world:null,topic:null};
  }
  function deriveSteps(input) {
    var a=cleanValues(input), legacy=!a.goal&&!!a.world;
    if(legacy) {
      var old=['world'];
      if(a.world==='help'){old.push('help');if(!a.help)return old;}
      var previous=route(a);
      if(a.world==='beauty'||(a.world==='help'&&a.help==='care')){old.push('beauty');if(!a.beauty)return old;}
      if(previous.topic==='collagen'){old.push('collagen');if(a.collagen==='plant')return old;}
      if(previous.topic==='lipcare')old.push('lipcare');
      if(previous.topic==='oil')old.push('oil');
      if(previous.topic==='tools')old.push('tools');
      if(previous.topic==='protein'){old.push('protein','proteinRoutine');if(a.proteinRoutine==='covered')return old;}
      if(previous.topic==='omega'){old.push('omegaRoutine');if(a.omegaRoutine==='covered')return old;}
      old.push('budget');return old;
    }
    var ids=['goal'];
    if(!a.goal)return ids;
    if(a.goal==='hair'){ids.push('hairFocus');if(!a.hairFocus)return ids;}
    if(a.goal==='nutrition'){ids.push('nutrition');if(!a.nutrition)return ids;}
    if(a.goal==='discover'){ids.push('discover');if(!a.discover)return ids;}
    if(a.goal==='skin'||(a.goal==='discover'&&a.discover==='care')){ids.push('beauty');if(!a.beauty)return ids;}
    var r=route(a);
    if(r.topic==='collagen'){
      ids.push('collagen');if(!a.collagen||a.collagen==='plant')return ids;
      if(a.goal==='hair'&&a.hairFocus!=='hair'&&a.collagen==='marine')return ids;
      // The extra discovery/skin question already consumes this route's fifth step.
      if(!(a.goal==='discover'&&a.discover==='care')){
        ids.push('collagenRoutine');if(!a.collagenRoutine||a.collagenRoutine==='covered')return ids;
      }
    }
    if(r.topic==='lipcare')ids.push('lipcare');
    if(r.topic==='oil')ids.push('oil');
    if(r.topic==='tools')ids.push('tools');
    if(r.topic==='protein'){
      ids.push('proteinRoutine');if(!a.proteinRoutine||a.proteinRoutine==='covered')return ids;
      ids.push('protein');
    }
    if(r.topic==='omega'){ids.push('omegaRoutine');if(!a.omegaRoutine||a.omegaRoutine==='covered')return ids;}
    ids.push('budget');return ids;
  }
  function sanitizeAnswers(input) {
    var a=cleanValues(input), out={};
    deriveSteps(a).forEach(function(id){if(a[id])out[id]=a[id];});
    return out;
  }
  function recommend(input, catalog) {
    var a=sanitizeAnswers(input), steps=deriveSteps(a), r=route(a), budget=a.budget==='40'?4000:a.budget==='60'?6000:null;
    var base={primaryKey:null,alternativeKey:null,optionalKey:null,state:'incomplete',budgetCents:budget,reasonKeys:[],summaryKeys:[],world:r.world,topic:r.topic,goal:r.goal||null,stateTitleKey:'state_incomplete_title',stateBodyKey:'state_incomplete_body'};
    function state(name,reasons) {base.state=name;base.stateTitleKey='state_'+name+'_title';base.stateBodyKey='state_'+name+'_body';base.reasonKeys=reasons||[];return base;}
    if(steps.some(function(id){return !validAnswer(id,a[id]);}))return base;
    base.summaryKeys=steps.filter(function(id){return a[id]&&id!=='world'&&id!=='help';}).map(function(id){return STEP_DEFS[id].options.find(function(o){return o.value===a[id];}).labelKey;});
    var preferred, alternative, allowSubstitute=false, reasons=[];
    if(r.topic==='collagen') {
      if(a.collagen==='plant')return state('no_match',['reason_plant_collagen']);
      if(a.goal==='hair'&&a.hairFocus!=='hair'&&a.collagen==='marine')return state('goal_no_match',['reason_nails_marine_no_match']);
      preferred=a.collagen==='marine'?'ocean':'valley';
      if(a.collagen==='either'){
        if(!(a.goal==='hair'&&a.hairFocus!=='hair')){alternative='ocean';allowSubstitute=true;}
        reasons.push(a.goal==='hair'&&a.hairFocus!=='hair'?'reason_nails_source_open':'reason_collagen_either');
      }else reasons.push('reason_'+preferred);
      if(a.collagenRoutine==='covered'){
        base.alternativeKey=eligible(preferred)?preferred:null;
        return state('no_more_needed',['reason_collagen_covered']);
      }
      if(a.collagenRoutine)reasons.push('reason_routine_'+a.collagenRoutine);
    } else if(r.topic==='lipcare') {
      preferred=a.lipcare==='trio'?'trio':'silk';reasons.push('reason_lipcare_'+a.lipcare);
    } else if(r.topic==='oil') {
      preferred=a.oil==='body'?'shimmer':'face';reasons.push('reason_oil_'+a.oil);
      if(a.oil==='compare')alternative='shimmer';
    } else if(r.topic==='tools') {
      preferred=a.tools==='cupping'?'cupping':'hotcold';reasons.push('reason_tools_'+a.tools);
      if(a.tools==='compare')alternative='cupping';
    } else if(r.topic==='protein') {
      preferred=a.protein==='whey'?'pure':'vegan';reasons.push('reason_protein_'+a.protein);
      if(a.protein==='either'){alternative='pure';allowSubstitute=true;}
      if(a.proteinRoutine==='covered') {base.alternativeKey=a.protein&&eligible(preferred)?preferred:null;return state('no_more_needed',['reason_protein_covered']);}
      reasons.push('reason_routine_'+a.proteinRoutine);
    } else if(r.topic==='omega') {
      preferred='omega';reasons.push('reason_omega');
      if(a.omegaRoutine==='covered'){base.alternativeKey=eligible(preferred)?preferred:null;return state('no_more_needed',['reason_omega_covered']);}
      reasons.push('reason_routine_'+a.omegaRoutine);
    } else return base;
    function known(key) {var p=catalog&&catalog[key];return !!(p&&typeof p.price==='number'&&Number.isFinite(p.price)&&p.price>=0&&typeof p.available==='boolean');}
    function eligible(key) {return known(key)&&catalog[key].available===true&&(budget===null||catalog[key].price<=budget);}
    if(!known(preferred))return state('error');
    if(!catalog[preferred].available) {
      if(allowSubstitute&&eligible(alternative)){preferred=alternative;alternative=null;reasons.push('reason_availability_choice');}
      else return state('unavailable',['reason_unavailable']);
    }
    if(budget!==null&&catalog[preferred].price>budget) {
      if(allowSubstitute&&eligible(alternative)){preferred=alternative;alternative=null;reasons.push('reason_budget_choice');}
      else {
        base.overBudgetKey=preferred;
        if(preferred==='trio'&&eligible('silk')) {base.alternativeKey='silk';base.alternativeReasonKey='alternative_single_gloss';}
        return state('budget',['reason_budget_limit']);
      }
    }
    if(r.topic==='collagen'&&a.goal){
      if(a.goal==='hair')reasons.push('reason_goal_'+(a.hairFocus==='hair'?'hair_'+preferred:a.hairFocus));
      else if(a.goal==='joints')reasons.push('reason_goal_cartilage');
      else if(a.goal==='skin')reasons.push('reason_goal_skin_formula');
    }
    base.primaryKey=preferred;
    if(alternative&&eligible(alternative))base.alternativeKey=alternative;
    if(base.alternativeKey)base.alternativeReasonKey='alternative_'+base.alternativeKey;
    if(budget!==null)reasons.push('reason_budget_'+a.budget);
    return state('match',reasons);
  }
  return {STEP_DEFS:STEP_DEFS,productMeta:productMeta,deriveSteps:deriveSteps,recommend:recommend,sanitizeAnswers:sanitizeAnswers,validAnswer:validAnswer};
  }());
  function option(value, key, detail) { return {value:value,labelKey:key,detailKey:detail||null}; }
  var RITUAL_STEPS = ['beautyWish','beautyTime','beautyApproach','beautySize','beautyBudget'];
  var STEP_DEFS = Object.assign({},legacy.STEP_DEFS,{
    beautyWish:{summaryLabelKey:"summary_beautyWish",titleKey:'step_beauty_wish_title',subtitleKey:'step_beauty_wish_subtitle',options:[option('natural','wish_natural','wish_natural_detail'),option('finish','wish_finish','wish_finish_detail'),option('care','wish_care','wish_care_detail'),option('allround','wish_allround','wish_allround_detail')]},
    beautyTime:{summaryLabelKey:"summary_beautyTime",titleKey:'step_beauty_time_title',subtitleKey:'step_beauty_time_subtitle',options:[option('quick','time_quick','time_quick_detail'),option('slow','time_slow','time_slow_detail')]},
    beautyApproach:{summaryLabelKey:"summary_beautyApproach",titleKey:'step_beauty_approach_title',subtitleKey:'step_beauty_approach_subtitle',options:[option('outside','approach_outside','approach_outside_detail'),option('mixed','approach_mixed','approach_mixed_detail'),option('plant','approach_plant','approach_plant_detail'),option('help','approach_help','approach_help_detail')]},
    beautySize:{summaryLabelKey:"summary_beautySize",titleKey:'step_beauty_size_title',subtitleKey:'step_beauty_size_subtitle',options:[option('one','size_one','size_one_detail'),option('few','size_few','size_few_detail'),option('complete','size_complete','size_complete_detail')]},
    beautyBudget:{summaryLabelKey:"summary_beautyBudget",titleKey:'step_beauty_budget_title',subtitleKey:'step_beauty_budget_subtitle',options:[option('50','beauty_budget_50'),option('100','beauty_budget_100'),option('150','beauty_budget_150'),option('any','beauty_budget_any')]},
    beautySource:{titleKey:'beauty_source_title',subtitleKey:'beauty_source_subtitle',options:[option('bovine','beauty_source_bovine'),option('marine','beauty_source_marine'),option('none','beauty_source_none')]}
  });
  var productMeta = Object.assign({},legacy.productMeta,{
    autumn:{handle:'the-autumn-glow-reset',world:'beauty',roleKey:'role_autumn',descriptionKey:'role_autumn',usageKey:'usage_autumn'}
  });
  function validAnswer(key,value) { return typeof value==='string' && !!STEP_DEFS[key] && Array.isArray(STEP_DEFS[key].options) && STEP_DEFS[key].options.some(function(o){return o.value===value;}); }
  function isLegacy(input) { return !validAnswer('beautyWish',input&&input.beautyWish) && !!(input&&(validAnswer('goal',input.goal)||validAnswer('world',input.world))); }
  function deriveSteps(input) { return isLegacy(input)?legacy.deriveSteps(input):RITUAL_STEPS.slice(); }
  function sanitizeAnswers(input) {
    if(isLegacy(input))return legacy.sanitizeAnswers(input);
    var out={},complete=true;
    RITUAL_STEPS.forEach(function(id){
      if(complete&&validAnswer(id,input&&input[id]))out[id]=input[id];
      else complete=false;
    });
    if(complete&&out.beautyApproach==='mixed'&&validAnswer('beautySource',input&&input.beautySource))out.beautySource=input.beautySource;
    return out;
  }
  function recommend(input,catalog) {
    if(isLegacy(input))return legacy.recommend(input,catalog);
    var a=sanitizeAnswers(input),limit=a.beautyBudget&&a.beautyBudget!=='any'?Number(a.beautyBudget)*100:null;
    var result={mode:'ritual',primaryKey:null,routineKeys:[],cosmeticKeys:[],supplementKey:null,alternativeKey:null,optionalKey:null,totalCents:0,budgetCents:limit,state:'incomplete',world:'beauty',topic:'ritual',goal:a.beautyWish||null,titleKey:'ritual_title_'+(a.beautyWish||'allround'),stateTitleKey:'state_incomplete_title',stateBodyKey:'state_incomplete_body',reasonKeys:[],summaryKeys:[],itemReasonKeys:{},reducedForBudget:false,reducedForAvailability:false,sourceEditable:false};
    if(RITUAL_STEPS.some(function(id){return !validAnswer(id,a[id]);}))return result;
    function addReason(key){if(result.reasonKeys.indexOf(key)<0)result.reasonKeys.push(key);}
    function known(key){var p=catalog&&catalog[key];return !!(p&&Number.isSafeInteger(p.price)&&p.price>0&&typeof p.available==='boolean');}
    function saleable(key){return known(key)&&catalog[key].available;}
    function fits(price,budget){return budget===null||price<=budget;}
    function state(name){result.state=name;result.stateTitleKey='state_'+name+'_title';result.stateBodyKey='state_'+name+'_body';return result;}
    function item(key){result.routineKeys.push(key);result.totalCents+=catalog[key].price;result.itemReasonKeys[key]='ritual_item_'+key;}
    result.summaryKeys=RITUAL_STEPS.map(function(id){return STEP_DEFS[id].options.find(function(o){return o.value===a[id];}).labelKey;});
    if(a.beautySource)result.summaryKeys.push(STEP_DEFS.beautySource.options.find(function(o){return o.value===a.beautySource;}).labelKey);
    addReason('ritual_reason_'+a.beautyWish);
    addReason('ritual_time_'+a.beautyTime);
    if(a.beautyApproach==='help')addReason('ritual_help_outside');

    // The same budget envelope is used for every collagen-source setting, including
    // "none". Changing this preference can only replace/remove the supplement.
    var mixed=a.beautyApproach==='mixed',plant=a.beautyApproach==='plant';
    var wantsSupplement=(mixed||plant)&&a.beautySize!=='one';
    result.sourceEditable=mixed&&a.beautySize!=='one';
    var supplement=mixed?(a.beautySource==='none'?null:a.beautySource==='marine'?'ocean':'valley'):plant?'omega':null;
    var reserveKeys=mixed?['valley','ocean']:plant?['omega']:[];
    var reserve=wantsSupplement?reserveKeys.reduce(function(max,key){return known(key)?Math.max(max,catalog[key].price):max;},0):0;
    var primaryCandidates=a.beautyWish==='finish'?['silk','shimmer']:['face','silk'];
    var cosmeticLimit=limit;
    if(wantsSupplement&&limit!==null&&reserve>0&&primaryCandidates.some(function(k){return saleable(k)&&catalog[k].price<=limit-reserve;}))cosmeticLimit=limit-reserve;
    var first=primaryCandidates.find(function(k){return saleable(k)&&fits(catalog[k].price,cosmeticLimit);});
    if(!first){
      if(primaryCandidates.some(function(k){return saleable(k);})){result.reducedForBudget=true;addReason('ritual_budget_no_match');return state('budget');}
      if(primaryCandidates.some(function(k){return !known(k);}))return state('error');
      addReason('reason_unavailable');return state('unavailable');
    }
    item(first);
    if(first!==primaryCandidates[0]){
      if(saleable(primaryCandidates[0])&&!fits(catalog[primaryCandidates[0]].price,cosmeticLimit)){result.reducedForBudget=true;addReason('ritual_lipcare_budget');}
      else {result.reducedForAvailability=true;addReason('ritual_alternative_available');}
    }
    // "One" is deliberately one beauty product. Supplements never displace it.
    if(a.beautySize==='one'){
      if(mixed||plant)addReason('ritual_one_beauty_first');
    }else{
      var candidates=[];
      if(a.beautyWish==='finish')candidates=first==='silk'?['shimmer']:['silk'];
      else if(a.beautyWish==='natural')candidates=a.beautyTime==='slow'&&a.beautySize==='complete'?['cupping','silk']:['silk'];
      else if(a.beautyWish==='care')candidates=a.beautyTime==='slow'?['hotcold','cupping','silk']:['silk'];
      else candidates=a.beautyTime==='slow'&&a.beautySize==='complete'?['silk','hotcold']:['silk'];
      var maxCosmetics=wantsSupplement?2:a.beautySize==='complete'?3:2;
      // A slow care ritual may have one tool, never two. Cupping needs Face Oil.
      candidates.forEach(function(key){
        if(result.routineKeys.indexOf(key)>=0||result.routineKeys.length>=maxCosmetics)return;
        var tool=key==='hotcold'||key==='cupping';
        if(tool&&(a.beautyTime!=='slow'||result.routineKeys.some(function(k){return k==='hotcold'||k==='cupping';})))return;
        if(key==='cupping'&&result.routineKeys.indexOf('face')<0)return;
        if(!saleable(key)){result.reducedForAvailability=true;return;}
        if(!fits(result.totalCents+catalog[key].price,cosmeticLimit)){result.reducedForBudget=true;return;}
        item(key);
      });
    }
    result.cosmeticKeys=result.routineKeys.slice();
    if(wantsSupplement&&supplement){
      if(saleable(supplement)&&fits(result.totalCents+catalog[supplement].price,limit)){
        item(supplement);result.supplementKey=supplement;
        if(plant)addReason('ritual_plant_scope');
      }else if(!saleable(supplement)){
        result.reducedForAvailability=true;addReason(known(supplement)?'ritual_supplement_unavailable':'ritual_supplement_unknown');
      }else{result.reducedForBudget=true;addReason('ritual_supplement_budget');}
    }
    if(mixed&&a.beautySource==='none')addReason('ritual_no_supplement');
    if(result.reducedForBudget)addReason('ritual_fewer_within_budget');
    if(result.reducedForAvailability)addReason('ritual_stock_selection');
    result.primaryKey=result.routineKeys[0];
    // Optional kits are alternatives to the selection, not extra routine steps.
    // Each kit's full contents are described separately.
    if(a.beautySize==='complete'){
      if(a.beautyWish==='finish'&&saleable('trio')&&fits(catalog.trio.price,limit)){
        result.alternativeKey='trio';result.alternativeReasonKey='ritual_bundle_trio';
      }else if((a.beautyWish==='natural'||a.beautyWish==='allround')&&mixed&&(!a.beautySource||a.beautySource==='bovine')&&saleable('autumn')&&fits(catalog.autumn.price,limit)){
        result.alternativeKey='autumn';result.alternativeReasonKey='ritual_bundle_autumn';
      }
    }
    if(result.routineKeys.length===2&&result.routineKeys.indexOf('silk')>=0&&result.routineKeys.indexOf('shimmer')>=0&&saleable('lipbody')&&!catalog.lipbody.priceVaries&&!catalog.silk.priceVaries&&!catalog.shimmer.priceVaries&&catalog.lipbody.price<result.totalCents&&fits(catalog.lipbody.price,limit)){
      result.alternativeKey='lipbody';result.alternativeReasonKey='lipbody_note';
      result.bundleSavingCents=result.totalCents-catalog.lipbody.price;
    }
    return state('match');
  }
  return {STEP_DEFS:STEP_DEFS,productMeta:productMeta,deriveSteps:deriveSteps,recommend:recommend,sanitizeAnswers:sanitizeAnswers,validAnswer:validAnswer,isLegacy:isLegacy};
}));


if (!customElements.get('kimaia-routine-quiz')) {
  class KimaiaRoutineQuiz extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      try { this.config = JSON.parse(this.querySelector('[data-routine-config]').textContent); }
      catch (_) { return; }
      this.strings = this.config.strings;
      this.catalog = this.config.catalog;
      this.engine = KimaiaRoutineEngine;
      this.answers = {};
      this.index = 0;
      this.panel = this.querySelector('[data-routine-panel]');

      this.counter = this.querySelector('[data-routine-counter]');
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-action]');
        if (!button || !this.contains(button)) return;
        if (button.dataset.action === 'answer') this.choose(button.dataset.value);
        if (button.dataset.action === 'source' && this.engine.validAnswer('beautySource',button.dataset.value)) { this.answers.beautySource = button.dataset.value; this.showResult(false); const source = this.panel.querySelector('.krq__source'); if (source) { source.open = true; source.querySelector('[aria-pressed="true"]')?.focus({preventScroll:true}); } }
        if (button.dataset.action === 'back') this.back();
        if (button.dataset.action === 'restart') this.restart();
        if (button.dataset.action === 'edit') { this.index = 0; this.showQuestion(true); }
      });
      this.addEventListener('submit', (event) => {
        if (!event.target.matches('[data-routine-email-form]')) return;
        event.preventDefault();
        this.sendEmail(event.target);
      });
      let restored = false;
      try {
        const raw = new URLSearchParams(location.hash.slice(1)).get('routine');
        if (raw && raw.length < 1200) {
          const decoded = JSON.parse(atob(raw));
          if ([2,4].includes(decoded.v) && decoded.a && typeof decoded.a === 'object') {
            const clean = {};
            for (const [id, value] of Object.entries(decoded.a)) {
              const def = this.engine.STEP_DEFS[id];
              if (def && def.options.some((option) => option.value === value)) clean[id] = value;
            }
            this.answers = this.engine.sanitizeAnswers(clean);
            const steps = this.steps();
            if (steps.length && steps.every((id) => !!clean[id])) {
              this.showResult(false);
              restored = true;
            }
          }
        }
      } catch (_) {}
      if (!restored) { this.answers = {}; this.showQuestion(false); }
    }
    t(key, params = {}) {
      let value = this.strings[key] || '';
      for (const [name, replacement] of Object.entries(params)) value = value.replaceAll(`{${name}}`, String(replacement));
      return value;
    }
    esc(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
    }
    steps() { return this.engine.deriveSteps(this.answers); }
    focusHeading() {
      requestAnimationFrame(() => {
        const heading = this.panel.querySelector('[data-routine-heading]');
        if (!heading) return;
        heading.focus({preventScroll:true});
        const top = this.getBoundingClientRect().top;
        if (top < 0 || top > window.innerHeight * .45) this.scrollIntoView({block:'start',behavior:'auto'});
      });
    }
    choose(value) {
      const steps = this.steps();
      const id = steps[this.index];
      const def = this.engine.STEP_DEFS[id];
      if (!def || !def.options.some((option) => option.value === value)) return;
      if (this.answers[id] !== value) {
        const retained = {};
        steps.slice(0, this.index).forEach((key) => { if (this.answers[key]) retained[key] = this.answers[key]; });
        this.answers = {...retained, [id]:value};
      }
      const next = this.steps();
      this.index += 1;
      if (this.index >= next.length) this.showResult(true);
      else this.showQuestion(true);
    }
    back() {
      this.index = Math.max(0, this.index - 1);
      this.showQuestion(true);
    }
    restart() {
      this.answers = {};
      this.index = 0;
      this.result = null;
      try { if (location.hash.startsWith('#routine=')) history.replaceState(null,'',location.pathname + location.search); } catch (_) {}
      this.showQuestion(true);
    }
    showQuestion(focus) {
      const steps = this.steps();
      const id = steps[this.index];
      const def = this.engine.STEP_DEFS[id];
      if (!def) return;
      this.classList.remove('krq--result');
      this.setAttribute('data-current-step', id);
      this.counter.textContent = this.t(this.answers.goal || this.answers.world ? 'question_counter' : 'v4_counter', {current:this.index + 1});





      this.querySelector('[data-routine-stage]').textContent = this.t('stage_choose');
      this.panel.innerHTML = `<div class="krq__question"><div class="krq__question-intro"><h2 tabindex="-1" data-routine-heading>${this.esc(this.t(def.titleKey))}</h2><p class="krq__lead">${this.esc(this.t(def.subtitleKey))}</p></div><div class="krq__question-choices"><div class="krq__options">${def.options.map((option, i) => `<button class="krq__option${this.answers[id] === option.value ? ' krq__option--selected' : ''}" type="button" data-action="answer" data-value="${this.esc(option.value)}"${this.answers[id] === option.value ? ' aria-current="true"' : ''}><span class="krq__option-copy"><span class="krq__option-title">${this.esc(this.t(option.labelKey))}</span>${option.detailKey && id !== "goal" ? `<span class="krq__option-detail">${this.esc(this.t(option.detailKey))}</span>` : ''}</span></button>`).join('')}</div><div class="krq__question-foot">${this.index > 0 ? `<button class="krq__text-button" type="button" data-action="back"> ${this.esc(this.t('back'))}</button>` : '<span></span>'}<p>${this.esc(this.t('auto_continue'))}</p></div></div></div>`;
      if (focus) this.focusHeading();
    }
    money(product) {
      const formatted = new Intl.NumberFormat(this.config.locale || 'nl-NL', {style:'currency',currency:this.config.currency || 'EUR'}).format(product.price / 100);
      return (product.priceVaries ? this.t('from_price') + ' ' : '') + formatted;
    }
    ritualCard(key, index) {
      const p = this.catalog[key], meta = this.engine.productMeta[key] || {};
      if (!p || !p.available) return '';
      const reason = this.t((this.result.itemReasonKeys || {})[key] || meta.roleKey);
      return `<article class="krq__ritual-card"><div class="krq__ritual-visual"><span class="krq__step-number">${String(index+1).padStart(2,'0')}</span>${p.image ? `<img src="${this.esc(p.image)}" width="240" height="240" alt="${this.esc(p.title)}" loading="lazy">` : ''}</div><div class="krq__ritual-copy"><p class="krq__eyebrow">${this.esc(this.t(['valley','ocean','omega'].includes(key) ? 'v4_part_inside' : ['silk','shimmer'].includes(key) ? 'v4_part_finish' : ['cupping','hotcold'].includes(key) ? 'v4_part_tool' : 'v4_part_care'))}</p><h3>${this.esc(p.title)}</h3><p class="krq__ritual-reason">${this.esc(reason)}</p><details class="krq__usage"><summary>${this.esc(this.t('v4_how_use'))}</summary><p>${this.esc(this.t(meta.usageKey))}</p></details><div class="krq__ritual-buy"><strong>${this.esc(this.money(p))}</strong><a class="krq__button" href="${this.esc(p.url)}">${this.esc(this.t('v4_choose_product'))}</a></div></div></article>`;
    }
    sourceControls() {
      if (this.answers.beautyApproach !== 'mixed' || this.answers.beautySize === 'one') return '';
      return `<details class="krq__source"><summary>${this.esc(this.t('v4_adjust_supplement'))}</summary><p>${this.esc(this.t('v4_source_note'))}</p><div class="krq__source-options">${[['bovine','v4_source_bovine'],['marine','v4_source_marine'],['none','v4_source_none']].map(([value,key]) => `<button type="button" data-action="source" data-value="${value}" aria-pressed="${(this.answers.beautySource || 'bovine') === value}">${this.esc(this.t(key))}</button>`).join('')}</div></details>`;
    }
    showRitualResult(focus) {
      const keys = this.result.routineKeys || [];
      this.nextStep = keys.map(key=>`${this.catalog[key].title}: ${this.t(this.engine.productMeta[key].usageKey)}`).join(' ');
      const summaryItems = this.steps().filter(id=>this.answers[id]).map(id=>{const def=this.engine.STEP_DEFS[id],opt=def.options.find(o=>o.value===this.answers[id]);return `<li><span>${this.esc(this.t(def.summaryLabelKey || 'your_choice'))}</span><strong>${this.esc(this.t(opt.labelKey))}</strong></li>`;}).join('');
      const title = this.t(this.result.titleKey || 'v4_result_title');
      const intro = this.t('ritual_reason_' + this.answers.beautyWish);
      const notes = (this.result.reasonKeys || []).filter(key => !key.startsWith('ritual_reason_') && !key.startsWith('ritual_time_')).map(key=>this.t(key)).filter(Boolean);
      const hasSupplement = keys.some(key=>['valley','ocean','omega'].includes(key));
      const total = this.money({price:this.result.totalCents || 0,priceVaries:keys.some(key=>this.catalog[key].priceVaries)});
      this.panel.innerHTML = `<div class="krq__ritual-intro"><div><p class="krq__eyebrow">${this.esc(this.t('v4_result_eyebrow'))}</p><h2 tabindex="-1" data-routine-heading>${this.esc(title)}</h2><p class="krq__lead">${this.esc(intro || this.t(this.result.stateBodyKey))}</p></div><figure class="krq__kim"><img src="https://kimaia.nl/cdn/shop/files/kimaia-kim-pet-water-bottle.jpg?v=1789959981&width=300" alt="Kim Feenstra" width="300" height="375" loading="lazy"><figcaption>Kim Feenstra · KIMAIA</figcaption></figure></div>${keys.length ? `<div class="krq__ritual-list">${keys.map((key,i)=>this.ritualCard(key,i)).join('')}</div><div class="krq__ritual-total"><div><span>${this.esc(this.t('v4_total'))}</span><p>${this.esc(this.t('v4_total_note'))}</p></div><strong>${this.esc(total)}</strong></div>${notes.length ? `<div class="krq__budget-explanation">${notes.map(note=>`<p>${this.esc(note)}</p>`).join('')}</div>` : ''}` : `<div class="krq__empty"><p>${this.esc(this.t(this.result.stateBodyKey))}</p><button type="button" class="krq__button" data-action="edit">${this.esc(this.t('edit_choices'))}</button></div>`}${this.sourceControls()}${this.result.alternativeKey ? `<section class="krq__bundle"><p class="krq__eyebrow">${this.esc(this.t(this.result.alternativeKey === 'lipbody' ? 'lipbody_heading' : 'v4_bundle_heading'))}</p>${this.productCard(this.result.alternativeKey,false)}</section>` : ''}<div class="krq__aftercare"><div><p class="krq__eyebrow">${this.esc(this.t('v4_next_heading'))}</p><p>${this.esc(this.t('v4_next_body'))}</p></div><details class="krq__answers"><summary>${this.esc(this.t('your_answers'))}<span aria-hidden="true">+</span></summary><ul>${summaryItems}</ul><button type="button" class="krq__text-button" data-action="edit">${this.esc(this.t('edit_choices'))}</button></details></div>${keys.length ? this.emailForm() : ''}<footer class="krq__result-footer"><p>${this.esc(this.t(hasSupplement ? 'advice_note' : 'advice_note_cosmetic'))}</p><button class="krq__text-button" type="button" data-action="restart">${this.esc(this.t('restart'))}</button></footer>`;
      if (focus) this.focusHeading();
    }

    productCard(key, primary) {
      const product = this.catalog[key];
      if (!product || !product.available || !Number.isFinite(product.price)) return '';
      const meta = this.engine.productMeta[key] || {};
      const bundleSaving = key === 'lipbody' && this.result.bundleSavingCents > 0 ? this.t('lipbody_saving', {saving:this.money({price:this.result.bundleSavingCents}),separate:this.money({price:this.result.totalCents})}) : '';
      return `<article class="krq__product${primary ? '' : ' krq__product--alternative'}"><a class="krq__product-image" href="${this.esc(product.url)}" tabindex="-1" aria-hidden="true">${product.image ? `<img src="${this.esc(product.image)}" alt="" width="560" height="560" loading="lazy">` : ''}</a><div class="krq__product-copy"><p class="krq__eyebrow">${this.esc(this.t(primary ? 'primary_label' : 'alternative_label'))}</p><h3>${this.esc(product.title)}</h3>${meta.descriptionKey ? `<p class="krq__product-description">${this.esc(this.t(meta.descriptionKey))}</p>` : ''}${primary ? `<div class="krq__why"><span>${this.esc(this.t('why_heading'))}</span><p>${this.esc(this.why)}</p></div>` : `<p class="krq__alternative-note">${this.esc(this.t(this.result.alternativeReasonKey || 'alternative_note'))}</p>`}${bundleSaving ? `<p class="krq__alternative-note"><strong>${this.esc(bundleSaving)}</strong></p>` : ''}<div class="krq__price">${this.esc(this.money(product))}<span>${this.esc(this.t('one_time_price'))}</span></div><a class="${primary ? 'krq__button' : 'krq__link'}" href="${this.esc(product.url)}">${this.esc(this.t(key === 'lipbody' ? 'lipbody_cta' : primary ? 'product_cta' : 'alternative_cta'))}</a></div></article>`;
    }
    resultUrl() {
      const url = new URL(location.pathname,this.config.storeUrl);
      url.hash = new URLSearchParams({routine:btoa(JSON.stringify({v:this.answers.beautyWish ? 4 : 2,a:this.answers}))}).toString();
      return url.href;
    }
    showResult(focus) {
      this.result = this.engine.recommend(this.answers,this.catalog);
      this.why = (this.result.reasonKeys || []).map((key) => this.t(key)).filter(Boolean).join(' ');
      this.summary = (this.result.summaryKeys || []).map((key) => this.t(key)).filter(Boolean).join(' · ');
      this.classList.add('krq--result');
      this.removeAttribute('data-current-step');




      this.counter.textContent = this.t('result_progress');
      this.querySelector('[data-routine-stage]').textContent = this.t('stage_result');
      if (this.result.mode === 'ritual') { this.showRitualResult(focus); return; }
      const primary = this.result.primaryKey;
      this.nextStep = primary ? this.t((this.engine.productMeta[primary] || {}).usageKey || 'next_body') : this.t('no_match_next');
      const overBudget = this.result.overBudgetKey && this.catalog[this.result.overBudgetKey];
      const budgetNote = overBudget ? `<p class="krq__budget-note">${this.esc(this.t('budget_actual_price',{product:overBudget.title,price:this.money(overBudget)}))}</p>` : ''; 
      const summaryItems = this.steps().filter((id) => !!this.answers[id]).map((id) => {
        const def = this.engine.STEP_DEFS[id];
        const option = def.options.find((o) => o.value === this.answers[id]);
        return `<li><span>${this.esc(this.t(def.summaryLabelKey || def.eyebrowKey || 'your_choice'))}</span><strong>${this.esc(this.t(option.labelKey))}</strong></li>`;
      }).join('');
      this.panel.innerHTML = `<div class="krq__result-intro"><p class="krq__eyebrow">${this.esc(this.t('result_eyebrow'))}</p><h2 tabindex="-1" data-routine-heading>${this.esc(this.t(primary ? 'result_title' : this.result.stateTitleKey || 'no_match_title'))}</h2><p class="krq__lead">${this.esc(primary ? this.t('result_intro') : this.t(this.result.stateBodyKey || 'no_match_body'))}</p></div>${primary ? this.productCard(primary,true) : `<div class="krq__empty"><span class="krq__empty-mark" aria-hidden="true">✦</span><p>${this.esc(this.why || this.t('no_match_reason'))}</p>${budgetNote}<button class="krq__button" type="button" data-action="edit">${this.esc(this.t('edit_choices'))}</button></div>`}${this.result.alternativeKey ? `<div class="krq__alternative-wrap">${this.productCard(this.result.alternativeKey,false)}</div>` : ''}<div class="krq__aftercare"><div><p class="krq__eyebrow">${this.esc(this.t('next_heading'))}</p><p>${this.esc(this.nextStep)}</p></div><details class="krq__answers"><summary>${this.esc(this.t('your_answers'))}<span aria-hidden="true">+</span></summary><ul>${summaryItems}</ul><button class="krq__text-button" type="button" data-action="edit">${this.esc(this.t('edit_choices'))}</button></details></div>${primary ? this.emailForm() : ''}<footer class="krq__result-footer"><p>${this.esc(this.t(['collagen','protein','omega'].includes(this.result.topic) ? 'advice_note' : 'advice_note_cosmetic'))}</p><button class="krq__text-button" type="button" data-action="restart">${this.esc(this.t('restart'))}</button></footer>`;
      if (focus) this.focusHeading();
    }
    emailForm() {
      return `<section class="krq__mail" aria-labelledby="krq-mail-title"><div class="krq__mail-intro"><p class="krq__eyebrow">${this.esc(this.t('mail_eyebrow'))}</p><h3 id="krq-mail-title">${this.esc(this.t('mail_title'))}</h3><p>${this.esc(this.t('mail_body'))}</p></div><form data-routine-email-form><div class="krq__mail-fields"><label>${this.esc(this.t('name_label'))}<input type="text" name="firstName" autocomplete="given-name" maxlength="70"></label><label>${this.esc(this.t('email_label'))}<input type="email" name="email" autocomplete="email" inputmode="email" required maxlength="254" aria-describedby="krq-mail-status"></label></div><label class="krq__consent"><input type="checkbox" name="newsletter"><span>${this.esc(this.t('newsletter_consent'))}</span></label><p class="krq__mail-privacy">${this.esc(this.t('mail_privacy'))} <a href="${this.esc(this.config.privacyUrl)}">${this.esc(this.t('privacy_link'))}</a></p><button class="krq__button" type="submit">${this.esc(this.t('mail_cta'))}</button><p id="krq-mail-status" class="krq__mail-status" role="status" aria-live="polite"></p></form></section>`;
    }
    async sendEmail(form) {
      if (!form.reportValidity() || form.dataset.sending === 'true') return;
      const status = form.querySelector('.krq__mail-status');
      const submit = form.querySelector('[type="submit"]');
      const formValues = new FormData(form);
      const safeProduct = (key) => {
        const p = this.catalog[key];
        if (!p) return null;
        return {title:p.title,url:new URL(p.url,this.config.storeUrl).href,image:p.image || '',price:this.money(p),priceCents:p.price,currency:this.config.currency};
      };
      const payload = {version:'2026-09',email:String(formValues.get('email') || '').trim(),firstName:String(formValues.get('firstName') || '').trim(),newsletterConsent:formValues.get('newsletter') === 'on',locale:this.config.locale,primary:safeProduct(this.result.primaryKey),alternative:this.result.alternativeKey ? safeProduct(this.result.alternativeKey) : null,why:this.why,summary:this.summary,nextStep:this.nextStep,alternativeNote:this.result.alternativeKey ? this.t(this.result.alternativeReasonKey || 'alternative_note') : '',resultsUrl:this.resultUrl()};
      if (this.result.mode === 'ritual' && this.result.routineKeys.length) {
        payload.routineItems = this.result.routineKeys.map(key => ({...safeProduct(key),reason:this.t(this.result.itemReasonKeys[key]),usage:this.t(this.engine.productMeta[key].usageKey)}));
        payload.routineTotal = this.money({price:this.result.totalCents,priceVaries:this.result.routineKeys.some(key=>this.catalog[key].priceVaries)});
        payload.routineTitle = this.t(this.result.titleKey || 'v4_result_title');
      }
      form.dataset.sending = 'true';
      submit.disabled = true;
      submit.textContent = this.t('mail_sending');
      status.textContent = '';
      status.classList.remove('krq__mail-status--error');
      try {
        if (typeof window.requestRoutineEmail !== 'function') throw new Error('Routine email is not connected');
        const confirmation = await window.requestRoutineEmail(payload);
        if (!confirmation || confirmation.ok !== true) throw new Error('Routine email was not confirmed');
        status.textContent = this.t(payload.newsletterConsent && confirmation.newsletterAccepted === false ? 'mail_success_newsletter_failed' : 'mail_success');
        submit.textContent = this.t('mail_sent');
        form.querySelectorAll('input').forEach((input) => { input.disabled = true; });
      } catch (_) {
        status.textContent = this.t('mail_error');
        status.classList.add('krq__mail-status--error');
        submit.disabled = false;
        submit.textContent = this.t('mail_retry');
      } finally { form.dataset.sending = 'false'; }
    }
  }
  customElements.define('kimaia-routine-quiz', KimaiaRoutineQuiz);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kimaia-share-glow"] && !Shopify.designMode) return;
  try {
    function kimaiaReferralProducts(){if(location.hash!=='#share-products')return;const details=document.getElementById('share-products');if(details)details.open=true;}
kimaiaReferralProducts();window.addEventListener('hashchange',kimaiaReferralProducts);document.addEventListener('shopify:section:load',kimaiaReferralProducts);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kimaia-shop-quick-add"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kimaia-shop-quick-add')) {
    customElements.define('kimaia-shop-quick-add', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.root = this.closest('#kshop,[data-ks-scope]');
        this.dialog = this.querySelector('dialog');
        this.text = JSON.parse(this.querySelector('[data-ks-text]').textContent);
        this.fields = {};
        ['close','eyebrow','title','image','price','loading','picker','choice','options','selection','submit','error','success','confirmation','details','subscription','links','check-cart','single','bundle-panel','progress','groups','included','quantity','quantity-label','minus','plus'].forEach(key => {
          this.fields[key] = this.dialog.querySelector('[data-ks-' + key + ']');
        });
        this.format = new Intl.NumberFormat(document.documentElement.lang || 'nl', {style:'currency',currency:this.dataset.currency || 'EUR'});
        this.onRootClick = event => {
          const trigger = event.target.closest('[data-ks-quick],[data-ks-direct]');
          if (!trigger || trigger.closest('#kshop,[data-ks-scope]') !== this.root || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !this.dialog.showModal) return;
          event.preventDefault();
          if (!this.busy) {
            if (trigger.hasAttribute('data-ks-direct')) this.addDirect(trigger);
            else this.open(trigger);
          }
        };
        this.root.addEventListener('click', this.onRootClick);
        this.dialog.addEventListener('click', event => {
          if (event.target.closest('[data-ks-close],[data-ks-continue]') && !this.busy) this.dialog.close();
          if (event.target.closest('[data-ks-cart],[data-ks-check-cart]')) {
            this.dialog.close();
            if (window.KimaiaDrawer && window.KimaiaDrawer.open) window.KimaiaDrawer.open();
            else window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
          }
          if (event.target === this.dialog && !this.busy) {
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
          }
        });
        this.dialog.addEventListener('cancel', event => { if (this.busy) event.preventDefault(); });
        this.dialog.addEventListener('close', () => {
          this.controller?.abort();
          document.body.classList.remove('ks-quick-open');
          this.restoreDirect();
          this.trigger?.focus({preventScroll:true});
        });
        this.fields.options.addEventListener('change', event => this.select(event.target.value));
        this.fields.submit.addEventListener('click', () => this.add());
        this.fields.quantity.addEventListener('input', () => { if (!this.busy) this.refreshQuantity(); });
        this.fields.quantity.addEventListener('change', () => { if (!this.busy) this.normalizeQuantity(); });
        this.fields.minus.addEventListener('click', () => this.stepQuantity(-1));
        this.fields.plus.addEventListener('click', () => this.stepQuantity(1));
        const selectBundleChoice = event => this.selectBundleChoice(event.target);
        this.fields.groups.addEventListener('click', selectBundleChoice);
        this.fields.groups.addEventListener('change', selectBundleChoice);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.root?.removeEventListener('click', this.onRootClick);
        document.body.classList.remove('ks-quick-open');
      }
      showError(message) {
        this.fields.error.textContent = message;
        this.fields.error.hidden = !message;
      }
      setImage(src) {
        this.fields.image.hidden = !src;
        if (src) this.fields.image.src = src;
      }
      label(variant) {
        if (!variant.title || variant.title === 'Default Title') return '';
        return this.text.flavors[variant.title.toLowerCase()] || variant.title;
      }
      restoreDirect() {
        if (!this.directTrigger) return;
        this.directTrigger.disabled = false;
        this.directTrigger.removeAttribute('aria-busy');
        this.directTrigger.removeAttribute('data-added');
        this.directTrigger.textContent = this.text.add;
        this.directTrigger = null;
      }
      prepare(trigger) {
        this.restoreDirect();
        this.trigger = trigger;
        this.controller?.abort();
        this.productUrl = new URL(trigger.dataset.ksUrl || trigger.href, window.location.origin);
        this.productUrl.search = '';
        this.productUrl.hash = '';
        this.selected = null;
        this.variants = [];
        this.isBundle = trigger.hasAttribute('data-ks-bundle');
        this.bundleGroups = null;
        this.bundleParent = null;
        this.bundleSummary = ''; 
        const f = this.fields;
        f.eyebrow.textContent = this.isBundle ? this.text.bundle_heading : this.text.heading;
        f.title.textContent = trigger.dataset.ksTitle;
        this.defaultImage = trigger.dataset.ksImage;
        this.setImage(this.defaultImage);
        f.price.textContent = '';
        f.choice.textContent = trigger.dataset.ksChoice || '';
        f.options.replaceChildren();
        f.groups.replaceChildren();
        f.included.replaceChildren();
        f['bundle-panel'].hidden = true;
        f.single.hidden = false;
        f.progress.hidden = false;
        f.selection.textContent = '';
        f.progress.style.setProperty('--ks-progress','0%');
        f.quantity.value = '1';
        f.quantity.disabled = false;
        f['quantity-label'].textContent = this.isBundle ? this.text.bundle_quantity : this.text.quantity;
        this.refreshQuantity();
        f.details.href = this.productUrl;
        f.subscription.hidden = !trigger.dataset.ksSubscription;
        if (trigger.dataset.ksSubscription) f.subscription.href = trigger.dataset.ksSubscription;
        f.loading.hidden = true;
        f.loading.textContent = this.text.loading;
        f.picker.hidden = true;
        f.success.hidden = true;
        f.links.hidden = false;
        f['check-cart'].hidden = true;
        f.submit.disabled = true;
        f.submit.textContent = this.text.choose_first;
        this.showError('');
      }
      reveal() {
        document.body.classList.add('ks-quick-open');
        if (!this.dialog.open) this.dialog.showModal();
      }
      async addDirect(trigger) {
        if (this.busy) return;
        const id = Number(trigger.dataset.ksVariant);
        const price = Number(trigger.dataset.ksPrice);
        if (!Number.isSafeInteger(id) || id <= 0 || !Number.isFinite(price)) return;
        this.prepare(trigger);
        this.directTrigger = trigger;
        this.selected = {id,price,title:'',available:true};
        this.variants = [this.selected];
        this.fields.price.textContent = this.format.format(price / 100);
        await this.add();
      }
      async open(trigger) {
        this.prepare(trigger);
        const controller = this.controller = new AbortController();
        const f = this.fields;
        f.loading.hidden = false;
        this.reveal();
        f.close.focus({preventScroll:true});
        try {
          const response = await fetch(this.productUrl.pathname + '.js', {credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store',signal:controller.signal});
          if (!response.ok) throw new Error();
          const product = await response.json();
          if (controller.signal.aborted || !this.dialog.open) return;
          if (product.requires_selling_plan || !Array.isArray(product.variants)) {
            this.showError(this.text.product_page);
            return;
          }
          if (this.isBundle) {
            const configUrl = new URL(this.productUrl);
            configUrl.searchParams.set('section_id', 'kimaia-bundle-quick-data');
            const configResponse = await fetch(configUrl, {credentials:'same-origin',cache:'no-store',signal:controller.signal});
            if (!configResponse.ok) throw new Error();
            const configDoc = new DOMParser().parseFromString(await configResponse.text(), 'text/html');
            const configNode = configDoc.querySelector('[data-ks-bundle-config]');
            if (!configNode) throw new Error();
            const config = JSON.parse(configNode.textContent);
            if (controller.signal.aborted || !this.dialog.open) return;
            if (Number(config.id) !== Number(product.id) || config.requiresSellingPlan) throw new Error();
            f['bundle-panel'].hidden = false;
            if (!config.native) {
              this.setupBundle(config, product);
              return;
            }
            f.progress.hidden = true;
            this.showIncluded(config.included || []);
            f.choice.textContent = this.text.bundle_heading + ' · Valley Glow';
          }
          this.variants = product.variants.filter(variant => !variant.requires_selling_plan);
          if (!this.variants.length) { this.showError(this.text.product_page); return; }
          f.price.textContent = this.format.format(product.price / 100);
          this.variants.forEach(variant => {
            const label = document.createElement('label');
            label.className = 'ks-quick__option';
            const input = document.createElement('input');
            input.type = 'radio';
            input.name = this.dialog.id + '-variant';
            input.value = String(variant.id);
            input.disabled = !variant.available;
            const caption = document.createElement('span');
            caption.textContent = this.label(variant) + (variant.available ? '' : ' · ' + this.text.unavailable);
            label.append(input, caption);
            f.options.append(label);
          });
          f.picker.hidden = false;
        } catch (error) {
          if (error.name !== 'AbortError') this.showError(this.text.loading_error);
        } finally {
          if (!controller.signal.aborted) f.loading.hidden = true;
        }
      }
      choiceLabel(value) {
        const short = value.includes(' - ') ? value.split(' - ').pop().trim() : value;
        return this.text.flavors[short.toLowerCase()] || short;
      }
      groupLabel(name) {
        return name.replace(/^Kies jouw /i, '').replace(/KIMAIA /g, '').replace(/ (smaak|kleur)$/i, '').trim();
      }
      parseBundleGroups(options) {
        if (!Array.isArray(options) || !options.length || options.length > 12) throw new Error();
        const names = new Set();
        return options.map(option => {
          if (!option.optionName || names.has(option.optionName) || typeof option.optionValues !== 'string') throw new Error();
          names.add(option.optionName);
          const stock = typeof option.optionInventories === 'string' ? option.optionInventories.split(',') : [];
          const choices = option.optionValues.split(',').map((raw, index) => {
            const value = raw.trim();
            if (!value || value.includes(' <> ')) throw new Error();
            const inventory = stock[index]?.trim();
            return {value,available:inventory === undefined || inventory === '' || (Number.isFinite(Number(inventory)) && Number(inventory) > 0)};
          });
          if (new Set(choices.map(choice => choice.value)).size !== choices.length) throw new Error();
          return {name:option.optionName,choices,fixed:choices.length === 1,selected:choices.length === 1 ? choices[0].value : null};
        });
      }
      bundleProperties() {
        if (!this.bundleGroups?.length) return null;
        const properties = {};
        const selections = [];
        for (const group of this.bundleGroups) {
          if (!group.choices.some(choice => choice.available && choice.value === group.selected)) return null;
          properties[group.name] = group.selected;
          selections.push(group.selected);
        }
        properties._bundle_selection = selections.join(' <> ');
        return properties;
      }
      showIncluded(items) {
        const container = this.fields.included;
        container.replaceChildren();
        container.hidden = !items.length;
        if (!items.length) return;
        const heading = document.createElement('p');
        heading.textContent = this.text.bundle_included;
        const list = document.createElement('ul');
        items.forEach(item => {const li=document.createElement('li');li.textContent=item;list.append(li);});
        container.append(heading,list);
      }
      setupBundle(config, product) {
        if (product.variants.length !== 1) throw new Error();
        const parent = product.variants.find(variant => Number(variant.id) === Number(config.variantId) && !variant.requires_selling_plan);
        if (!parent) throw new Error();
        this.bundleGroups = this.parseBundleGroups(config.options);
        this.bundleParent = parent;
        this.variants = [parent];
        const f = this.fields;
        f.single.hidden = true;
        f.price.textContent = this.format.format(parent.price / 100);
        let count = 0;
        this.bundleGroups.forEach((group,index) => {
          if (group.fixed) return;
          const details = document.createElement('details');
          details.className = 'ks-quick__group';
          details.name = this.dialog.id + '-bundle';
          details.open = count === 0;
          group.details = details;
          const summary = document.createElement('summary');
          const title = document.createElement('span');
          title.textContent = (++count) + '. ' + this.groupLabel(group.name);
          const status = document.createElement('span');
          status.className = 'ks-quick__group-status';
          status.textContent = this.text.bundle_unselected;
          summary.append(title,status);
          group.status = status;
          const fieldset = document.createElement('fieldset');
          fieldset.className = 'ks-quick__fieldset';
          const legend = document.createElement('legend');
          legend.textContent = group.name;
          const options = document.createElement('div');
          options.className = 'ks-quick__options';
          group.choices.forEach((choice,choiceIndex) => {
            const label = document.createElement('label');
            label.className = 'ks-quick__option';
            const input = document.createElement('input');
            input.type = 'radio';
            input.name = this.dialog.id + '-group-' + index;
            input.dataset.bundleGroup = index;
            input.value = choiceIndex;
            input.disabled = !choice.available;
            const caption = document.createElement('span');
            caption.textContent = this.choiceLabel(choice.value) + (choice.available ? '' : ' · ' + this.text.unavailable);
            label.append(input,caption);options.append(label);
          });
          fieldset.append(legend,options);details.append(summary,fieldset);f.groups.append(details);
        });
        this.showIncluded(this.bundleGroups.filter(group=>group.fixed).map(group=>group.selected));
        this.updateBundle();
        f.picker.hidden = false;
      }
      selectBundleChoice(input) {
        if (this.busy || !input.matches('input[type="radio"][data-bundle-group]') || !input.checked || input.disabled) return;
        const index = Number(input.dataset.bundleGroup);
        const group = this.bundleGroups?.[index];
        if (!group?.details?.open) return;
        const choice = group.choices[Number(input.value)];
        if (!choice?.available) return;
        group.selected = choice.value;
        this.updateBundle();
        group.details.open = false;
        const next = this.bundleGroups.slice(index + 1).concat(this.bundleGroups.slice(0, index)).find(item => !item.fixed && !item.selected);
        if (next) next.details.open = true;
        const target = next ? next.details.querySelector('summary') : !this.fields.submit.disabled ? this.fields.submit : group.details.querySelector('summary');
        target.focus({preventScroll:true});
        if (next) {
          const scroller = this.fields.groups.closest('.ks-quick__choices');
          const viewport = scroller.getBoundingClientRect();
          const panel = next.details.getBoundingClientRect();
          if (panel.top < viewport.top + 4) scroller.scrollTop += panel.top - viewport.top - 4;
          else if (panel.bottom > viewport.bottom - 4) scroller.scrollTop += Math.min(panel.bottom - viewport.bottom + 4, panel.top - viewport.top - 4);
        }
      }
      updateBundle() {
        const choices = this.bundleGroups.filter(group=>!group.fixed);
        const chosen = choices.filter(group=>group.selected);
        const f = this.fields;
        f.progress.textContent = chosen.length + ' ' + this.text.bundle_of + ' ' + choices.length + ' ' + this.text.bundle_selected;
        choices.forEach(group => { if(group.status) group.status.textContent = group.selected ? this.choiceLabel(group.selected) : this.text.bundle_unselected; });
        this.bundleSummary = chosen.map(group=>this.groupLabel(group.name) + ': ' + this.choiceLabel(group.selected)).join(' · ');
        const ready = this.bundleParent.available && !!this.bundleProperties();
        this.selected = ready ? this.bundleParent : null;
        f.selection.textContent = chosen.length + ' ' + this.text.bundle_of + ' ' + choices.length + ' ' + this.text.bundle_selected + (this.bundleSummary ? ' · ' + this.bundleSummary : '');
        f.progress.style.setProperty('--ks-progress', (100 * chosen.length / choices.length) + '%');
        this.normalizeQuantity();
        const unavailable = !this.bundleParent.available || this.bundleGroups.some(group=>!group.choices.some(choice=>choice.available));
        this.showError(unavailable ? this.text.unavailable : '');
      }
      select(id) {
        if (this.busy) return;
        this.selected = this.variants.find(variant => String(variant.id) === id && variant.available);
        const f = this.fields;
        f.submit.disabled = !this.selected;
        if (!this.selected) return;
        f.price.textContent = this.format.format(this.selected.price / 100);
        f.selection.textContent = this.label(this.selected);
        this.normalizeQuantity();
        this.setImage(this.selected.featured_image?.src || this.defaultImage);
        const details = new URL(this.productUrl);
        details.searchParams.set('variant', this.selected.id);
        f.details.href = details;
        if (this.trigger.dataset.ksSubscription) {
          const subscription = new URL(this.trigger.dataset.ksSubscription, window.location.origin);
          subscription.searchParams.set('variant', this.selected.id);
          f.subscription.href = subscription;
        }
        this.showError('');
      }
      quantityLimits() {
        const rule = (this.selected || this.bundleParent)?.quantity_rule || {};
        const min = Number.isSafeInteger(rule.min) && rule.min > 0 ? rule.min : 1;
        const step = Number.isSafeInteger(rule.increment) && rule.increment > 0 ? rule.increment : 1;
        const max = Number.isSafeInteger(rule.max) && rule.max >= min ? rule.max : null;
        return {min,step,max};
      }
      readQuantity() {
        const raw = this.fields.quantity.value.trim();
        const value = Number(raw);
        const {min,step,max} = this.quantityLimits();
        return /^\d+$/.test(raw) && Number.isSafeInteger(value) && value >= min && (max === null || value <= max) && (value - min) % step === 0 ? value : null;
      }
      refreshQuantity() {
        const f = this.fields;
        const {min,step,max} = this.quantityLimits();
        f.quantity.min = String(min);
        f.quantity.step = String(step);
        if (max === null) f.quantity.removeAttribute('max');
        else f.quantity.max = String(max);
        const quantity = this.readQuantity();
        f.minus.disabled = this.busy || !quantity || quantity <= min;
        f.plus.disabled = this.busy || !quantity || (max !== null && quantity + step > max);
        f.submit.disabled = this.busy || !this.selected?.available || !quantity;
        if (!this.busy) f.submit.textContent = !quantity ? this.text.quantity_invalid : this.selected ? (this.isBundle ? this.text.bundle_add : this.text.add) + ' · ' + this.format.format(this.selected.price * quantity / 100) : this.isBundle ? this.text.bundle_choose : this.text.choose_first;
      }
      normalizeQuantity() {
        const {min,step,max} = this.quantityLimits();
        const raw = Number(this.fields.quantity.value);
        let quantity = Number.isSafeInteger(raw) && raw >= min ? raw : min;
        if (max !== null) quantity = Math.min(quantity,max);
        quantity = min + Math.floor((quantity - min) / step) * step;
        this.fields.quantity.value = String(quantity);
        this.refreshQuantity();
      }
      stepQuantity(direction) {
        if (this.busy) return;
        const quantity = this.readQuantity();
        if (!quantity) return;
        this.fields.quantity.value = String(quantity + direction * this.quantityLimits().step);
        this.normalizeQuantity();
      }
      async add() {
        if (this.busy || !this.selected || !this.selected.available) return;
        const quantity = this.readQuantity();
        if (!quantity) { this.refreshQuantity(); return; }
        const properties = this.bundleGroups ? this.bundleProperties() : null;
        if (this.bundleGroups && !properties) return;
        this.busy = true;
        const variant = this.selected;
        const f = this.fields;
        f.submit.disabled = true;
        f.close.disabled = true;
        f.quantity.disabled = true;
        f.minus.disabled = true;
        f.plus.disabled = true;
        f.submit.textContent = this.text.adding;
        f.submit.setAttribute('aria-busy','true');
        if (this.directTrigger) {
          this.directTrigger.disabled = true;
          this.directTrigger.setAttribute('aria-busy','true');
          this.directTrigger.textContent = this.text.adding;
        }
        f.picker.setAttribute('aria-busy','true');
        f.options.querySelectorAll('input').forEach(input => { input.disabled = true; });
        f.groups.querySelectorAll('input').forEach(input => {input.disabled = true;});
        this.showError('');
        let rejected = false;
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method:'POST',credentials:'same-origin',
            headers:{'Content-Type':'application/json',Accept:'application/json','X-Kimaia-Quick-Add':'true'},
            body:JSON.stringify({items:[{id:variant.id,quantity,...(properties ? {properties} : {})}],sections:['cart-icon-bubble'],sections_url:window.location.pathname})
          });
          rejected = !response.ok;
          const data = await response.json();
          if (rejected || data.status) throw new Error(data.description || this.text.error);
          const html = data.sections?.['cart-icon-bubble'];
          if (html) {
            const documentFragment = new DOMParser().parseFromString(html,'text/html');
            const bubble = documentFragment.getElementById('shopify-section-cart-icon-bubble');
            const current = document.getElementById('cart-icon-bubble');
            if (bubble && current) current.replaceChildren(...bubble.childNodes);
          }
          f.picker.hidden = true;
          f.links.hidden = true;
          f.eyebrow.textContent = this.isBundle ? this.text.bundle_success : this.text.success_heading;
          const added = data.items?.find(item => Number(item.variant_id || item.id) === Number(variant.id));
          const actualPrice = added?.final_price ?? added?.price;
          f.price.textContent = this.format.format((Number.isFinite(actualPrice) ? actualPrice : variant.price) * quantity / 100);
          const label = this.bundleGroups ? this.bundleSummary : this.label(variant);
          f.confirmation.textContent = (quantity > 1 ? quantity + ' × ' : '') + this.trigger.dataset.ksTitle + (label ? ' · ' + label : '') + ' — ' + this.text.added;
          f.success.hidden = false;
          if (this.directTrigger) {
            this.directTrigger.removeAttribute('aria-busy');
            this.directTrigger.setAttribute('data-added','');
            this.directTrigger.textContent = this.text.button_added;
          }
          this.reveal();
          f.confirmation.focus({preventScroll:true});
        } catch (error) {
          this.showError(rejected ? error.message || this.text.error : this.text.uncertain);
          f['check-cart'].hidden = rejected;
          if (this.directTrigger) {
            this.directTrigger.removeAttribute('aria-busy');
            this.directTrigger.textContent = this.text.add;
            this.reveal();
            f.error.setAttribute('tabindex','-1');
            f.error.focus({preventScroll:true});
          }
        } finally {
          this.busy = false;
          f.close.disabled = false;
          f.picker.removeAttribute('aria-busy');
          f.submit.removeAttribute('aria-busy');
          f.options.querySelectorAll('input').forEach(input => {
            input.disabled = !this.variants.find(item => String(item.id) === input.value)?.available;
          });
          f.groups.querySelectorAll('input').forEach(input => {
            input.disabled = !this.bundleGroups?.[Number(input.dataset.bundleGroup)]?.choices[Number(input.value)]?.available;
          });
          f.quantity.disabled = false;
          this.refreshQuantity();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kimaia-video-captions"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kimaia-video-captions')) {
    customElements.define('kimaia-video-captions', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => this.addCaptions());
      }

      disconnectedCallback() {
        this.captionObserver?.disconnect();
        this.captionController?.abort();
        this.captionOverlay?.remove();
        this.captionToggle?.remove();
      }

      wrapCaption(text) {
        const width = Math.max(90, this.captionVideo.getBoundingClientRect().width * 0.84);
        const fontSize = Math.max(1, this.captionVideo.getBoundingClientRect().width * 0.055);
        this.captionMeasure.font = `${fontSize}px Arial`;
        const lines = [];
        let line = '';
        text.split(/\s+/).forEach(word => {
          const next = line ? `${line} ${word}` : word;
          if (line && this.captionMeasure.measureText(next).width > width) {
            lines.push(line);
            line = word;
          } else {
            line = next;
          }
        });
        if (line) lines.push(line);
        return lines.join('\n');
      }

      refreshCaptions() {
        this.captionBindings?.forEach(({ cue, text }) => {
          cue.text = this.wrapCaption(text);
          if (this.dataset.position === 'studio') {
            cue.line = Math.max(12, 51 - cue.text.split('\n').length * 3);
          }
        });
        this.renderOverlay();
      }

      renderOverlay() {
        if (!this.captionOverlay) return;
        const video = this.captionVideo;
        const width = video.clientWidth;
        const caption = this.captionLines.find(line => video.currentTime >= line.start && video.currentTime < line.end);
        this.captionOverlay.hidden = this.nativeFullscreen || !this.captionsEnabled || !caption;
        this.captionOverlay.textContent = caption?.text || '';
        Object.assign(this.captionOverlay.style, {
          left: `${video.offsetLeft + width * .05}px`,
          top: `${video.offsetTop + video.clientHeight - 74}px`,
          width: `${width * .9}px`,
          fontSize: `${Math.max(15, Math.min(24, width * .047))}px`
        });
        this.captionToggle.hidden = this.nativeFullscreen;
        this.captionToggle.setAttribute('aria-pressed', String(this.captionsEnabled));
        this.captionToggle.style.top = `${video.offsetTop + 10}px`;
        this.captionToggle.style.left = `${video.offsetLeft + width - 50}px`;
      }

      setFullscreen(active) {
        if (!this.captionOverlay) return;
        this.nativeFullscreen = active;
        this.captionTrack.mode = this.captionsEnabled ? (active ? 'showing' : 'hidden') : 'disabled';
        this.refreshCaptions();
      }

      addCaptions() {
        const video = this.closest('video');
        const template = this.querySelector('template');
        if (!video || !template || this.captionVideo === video || !window.VTTCue) return;
        const cues = Array.from(template.content.querySelectorAll('[data-start]')).map(line => ({
          start: Number(line.dataset.start),
          end: Number(line.dataset.end),
          text: line.textContent.trim()
        })).filter(cue => Number.isFinite(cue.start) && Number.isFinite(cue.end) && cue.start >= 0 && cue.end > cue.start && cue.text);
        if (!cues.length) return;
        this.captionVideo = video;
        video.classList.add('kimaia-captioned');
        video.classList.toggle('kimaia-captioned--studio', this.dataset.position === 'studio');
        this.captionMeasure = document.createElement('canvas').getContext('2d');
        this.captionBindings = [];
        const track = video.addTextTrack('subtitles', this.dataset.label, this.dataset.language);
        this.captionTrack = track;
        this.captionLines = cues;
        cues.forEach(caption => {
          const cue = new VTTCue(caption.start, caption.end, this.wrapCaption(caption.text));
          if (this.dataset.position === 'studio') {
            cue.snapToLines = false;
            cue.line = 51;
            cue.lineAlign = 'start';
          } else {
            cue.line = -1;
          }
          cue.size = 90;
          cue.align = 'center';
          cue.position = 50;
          cue.positionAlign = 'center';
          track.addCue(cue);
          this.captionBindings.push({ cue, text: caption.text });
        });
        this.captionController = new AbortController();
        const options = { signal: this.captionController.signal };
        this.captionsEnabled = true;
        if (this.dataset.position !== 'studio') {
          const host = video.parentElement;
          host.classList.add('kimaia-caption-host');
          this.captionOverlay = document.createElement('span');
          this.captionOverlay.className = 'kimaia-caption-overlay';
          this.captionOverlay.setAttribute('aria-hidden', 'true');
          this.captionToggle = document.createElement('button');
          this.captionToggle.type = 'button';
          this.captionToggle.className = 'kimaia-caption-toggle';
          this.captionToggle.textContent = 'CC';
          this.captionToggle.setAttribute('aria-label', `CC — ${this.dataset.label}`);
          host.append(this.captionOverlay, this.captionToggle);
          this.captionToggle.addEventListener('click', () => {
            this.captionsEnabled = !this.captionsEnabled;
            track.mode = this.captionsEnabled ? 'hidden' : 'disabled';
            this.renderOverlay();
          }, options);
          ['timeupdate', 'seeked', 'loadedmetadata', 'play', 'pause', 'ended'].forEach(event => video.addEventListener(event, () => this.renderOverlay(), options));
          video.textTracks.addEventListener('change', () => {
            if (track.mode === 'showing') {
              this.captionsEnabled = true;
              if (!this.nativeFullscreen) track.mode = 'hidden';
            } else if (track.mode === 'disabled') this.captionsEnabled = false;
            this.renderOverlay();
          }, options);
          track.mode = 'hidden';
        } else track.mode = 'showing';
        this.refreshCaptions();
        window.addEventListener('resize', () => this.refreshCaptions(), options);
        document.addEventListener('fullscreenchange', () => this.setFullscreen(document.fullscreenElement === video), options);
        video.addEventListener('webkitbeginfullscreen', () => this.setFullscreen(true), options);
        video.addEventListener('webkitendfullscreen', () => this.setFullscreen(false), options);
        this.captionObserver = new ResizeObserver(() => this.refreshCaptions());
        this.captionObserver.observe(video);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
